import { NgIf, NgFor } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { AgrExtendedNotificationModule } from '@next/core-lib/components';
import { LocaleService, AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { setBannerNotificationVisibility } from '../store/actions';
import { selectBannerNotificationVisibility } from '../store/selectors';

@Component({
  selector: 'app-information-banner',
  templateUrl: './information-banner.component.html',
  styleUrl: './information-banner.component.scss',
  imports: [AgrExtendedNotificationModule, NgIf, NgFor, AgrI18nSharedModule],
})
export class InformationBannerComponent implements OnInit, OnDestroy {
  public showNotification = true;
  public texts: { title: string; description: string }[] = [];
  private subscription: Subscription;

  constructor(
    private readonly store: Store<RootState>,
    private readonly localeService: LocaleService,
  ) {
    this.texts = [
      {
        title: 'app.banner-notification.paragraph-1.title',
        description: 'app.banner-notification.paragraph-1.description',
      },
      {
        title: 'app.banner-notification.paragraph-2.title',
        description: 'app.banner-notification.paragraph-2.description',
      },
      {
        title: 'app.banner-notification.paragraph-3.title',
        description: 'app.banner-notification.paragraph-3.description',
      },
      {
        title: 'app.banner-notification.paragraph-4.title',
        description: 'app.banner-notification.paragraph-4.description',
      },
      {
        title: 'app.banner-notification.paragraph-5.title',
        description: 'app.banner-notification.paragraph-5.description',
      },
    ];
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.subscription = this.store.select(selectBannerNotificationVisibility).subscribe((visible) => (this.showNotification = visible));
  }

  public getActionText() {
    return this.showNotification
      ? this.localeService.translate('app.banner-notification.action-text-close')
      : this.localeService.translate('app.banner-notification.action-text-open');
  }

  public toggleNotification() {
    this.store.dispatch(setBannerNotificationVisibility({ visible: !this.showNotification }));
  }
}
